<div>
  <atlas-profiler-import-summary
    [deletionDate]="deletionDate"
  >
  </atlas-profiler-import-summary>
  <mat-divider></mat-divider>
  <atlas-profiler-base-classification-selection></atlas-profiler-base-classification-selection>
  <mat-divider></mat-divider>
  <atlas-profiler-export-button
    [deletionDate]="deletionDate"
  >
  </atlas-profiler-export-button>
  <mat-divider></mat-divider>
</div>
